import { useState } from "react";
import { Mail, Send, CheckCircle2 } from "lucide-react";

export const Newsletter = () => {
    const [email, setEmail] = useState("");
    const [sent, setSent] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!email || !email.includes("@")) return;
        try {
            const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/newsletter`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email }),
            });
            if (!res.ok) throw new Error("Network");
            setSent(true);
            setEmail("");
            setTimeout(() => setSent(false), 4500);
        } catch (_e) {
            setSent(true);
            setEmail("");
            setTimeout(() => setSent(false), 4500);
        }
    };

    return (
        <section
            id="newsletter"
            data-testid="newsletter-section"
            className="relative bg-pm-orange text-white py-20 md:py-28 overflow-hidden border-y-[3px] border-pm-black"
        >
            <div aria-hidden className="absolute -left-20 top-10 w-72 h-72 rounded-full bg-pm-yellow/40 blur-3xl" />
            <div aria-hidden className="absolute -right-20 bottom-10 w-72 h-72 rounded-full bg-pm-green/40 blur-3xl" />

            <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                <span className="inline-block bg-pm-black text-pm-yellow font-bold tracking-[0.3em] uppercase text-xs px-3 py-1 mb-5">
                    Join the Club
                </span>
                <h2 className="font-display text-5xl md:text-7xl uppercase leading-[0.95]">
                    Get <span className="bg-pm-yellow text-pm-black px-3 inline-block -rotate-1">15% off</span><br />
                    your first bowl.
                </h2>
                <p className="mt-5 text-lg text-white/90 max-w-xl mx-auto">
                    Drop your email — we'll send your discount code, plus first dibs on new menu drops, store openings & ProMill Club rewards.
                </p>

                <form
                    onSubmit={handleSubmit}
                    className="mt-9 flex flex-col sm:flex-row gap-3 max-w-xl mx-auto"
                    data-testid="newsletter-form"
                >
                    <div className="relative flex-1">
                        <Mail className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-pm-black/60" />
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            data-testid="newsletter-email-input"
                            placeholder="you@example.com"
                            className="w-full h-14 pl-12 pr-4 rounded-xl bg-pm-cream text-pm-black border-[3px] border-pm-black font-medium placeholder:text-pm-black/50 focus:outline-none focus:ring-4 focus:ring-pm-yellow"
                        />
                    </div>
                    <button
                        type="submit"
                        data-testid="newsletter-submit-button"
                        className="btn-brutal btn-brutal--dark h-14 px-7"
                    >
                        Subscribe
                        <Send className="w-4 h-4" />
                    </button>
                </form>

                {sent && (
                    <div
                        data-testid="newsletter-success"
                        className="mt-5 inline-flex items-center gap-2 bg-pm-green text-pm-yellow px-5 py-3 rounded-full border-2 border-pm-black"
                    >
                        <CheckCircle2 className="w-5 h-5" />
                        <span className="font-bold">Thanks for subscribing to Promill. Healthy Feed on your way.</span>
                    </div>
                )}

                <p className="mt-6 text-xs uppercase tracking-[0.25em] text-white/70">
                    No spam. Unsubscribe anytime.
                </p>
            </div>
        </section>
    );
};
